import * as ng from 'angular';
import {ArchiSmallServices} from '../../../services/archismall.service';
import {IListini} from '../../interfaces/listini';
import {IRivenditore} from '../../interfaces/IRivenditore';

class EditRivenditoreModalController implements ng.IController {

  static $inject: string[] = [
    '$scope',
    '$rootScope',
    'ArchiSmallServices',
    '$timeout',
    '$uibModalStack',
    '$state'
  ];

  private close: any;
  private dismiss: any;

  constructor(
    private $scope: {
      rivenditore: IRivenditore
      form?: ng.IFormController
      formsubmitted?: boolean
      messaggio?: string
      [key: string]: any
    },
    private $rootScope: any,
    private ArchiSmallServices: ArchiSmallServices,
    private $timeout: ng.ITimeoutService,
    private $modalStack: ng.ui.bootstrap.IModalStackService,
    private $state: any
  ) {
    $scope.rivenditore = JSON.parse(JSON.stringify($scope.$parent.$resolve.rivenditore)) as IListini;
    $scope.codeRegex = /^[a-zA-Z0-9]{5}$/;

    $scope.formsubmitted = false;

    $scope.registerReseller = () => {
      $scope.formsubmitted = true;

      if ($scope.form && !$scope.form.$valid) {
        $scope.messaggio = 'Compila correttamente tutti i campi obbligatori';
        return;
      }

      ArchiSmallServices.registerRivenditore($scope.rivenditore).then(
        () => {
          this.close({$value: true});
        }).catch(err => {
          $scope.messaggio = `Error while register:  ${err.data.errorDescription}`;
        }
      );
    };

    $scope.modifyReseller = () => {

      $scope.formsubmitted = true;

      if ($scope.form && !$scope.form.$valid) {
        $scope.messaggio = 'Compila correttamente tutti i campi obbligatori';
        return;
      }
      ArchiSmallServices.updateRivenditore($scope.rivenditore).then(() => {
        this.close({$value: true});
      }).catch(err => {
        $scope.messaggio = `Error while editing:  ${err.data.errorDescription}`;
      });

    };
    $scope.annulla = () => {
      this.close({$value: false});
    };
  }
}

export const EditRivenditoreModalComponent: ng.IComponentOptions = {
  template: require('./edit-rivenditore-modal.html'),
  controller: EditRivenditoreModalController,
  bindings: {
    close: '&',
    dismiss: '&'
  }
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/commons/components/edit-rivenditore-modal/edit-rivenditore-modal.ts